<div class="flex flex-col h-full w-full bg-gray-50 dark:bg-transparent">

    <div class="flex-shrink-0 flex flex-col sm:flex-row sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-gray-800">
        <div class="flex-1 min-w-0">
            <div class="text-3xl font-extrabold tracking-tight leading-7 sm:leading-10">
                {{ termItems }}
            </div>
            <div class="text-secondary" *ngIf="destinationType?.ds_name">
                For {{ destinationType.ds_name }}
            </div>
        </div>
        <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
            <button
                *ngIf="!reviewMode"
                mat-flat-button
                [color]="'primary'"
                (click)="openOfferDialog('new')">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2">Add {{ termItem }}</span>
            </button>
        </div>
    </div>

    <div *ngIf="globalAlerts.length > 0" class="px-6 pt-6 sm:px-10 flex flex-col gap-3">
        <div *ngFor="let alert of globalAlerts"
             class="p-4 rounded-lg font-bold shadow-sm flex items-center gap-3"
             [ngClass]="alert.type === 'critical' ? 'bg-red-100 text-red-700 border border-red-300 animate-pulse' : 'bg-orange-100 text-orange-700 border border-orange-300'">
            <mat-icon [svgIcon]="'heroicons_outline:exclamation-triangle'" class="text-current"></mat-icon>
            <span>{{ alert.message }}</span>
        </div>
    </div>

    <div class="flex-auto overflow-y-auto p-6 sm:p-10">
        <ng-container *ngIf="!isLoading && specialOffersList.length > 0; else noOffers">
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                <mat-card class="flex flex-col relative overflow-hidden transition-shadow hover:shadow-lg" *ngFor="let offer of specialOffersList" [ngClass]="getOfferDetailedStatus(offer.dt_start, offer.dt_end).type === 'EXPIRED' ? 'opacity-70 grayscale-[30%]' : ''">
                    <div *ngIf="!isOfferValid(offer)"
                         class="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded text-xs font-bold animate-pulse shadow-md z-10"
                         [matTooltip]="'Missing Fields: ' + getMissingFields(offer).join(', ')">
                        ⚠️ Incomplete
                    </div>

                    <img mat-card-image [src]="offer.im_media" class="h-48 object-cover w-full m-0"
                         onerror="this.src='./assets/images/other/no-image-placeholder.png'">
                    <mat-card-header class="mt-4 px-4">
                        <mat-card-title class="line-clamp-2 text-lg font-bold leading-tight">{{ offer.ds_offer }}</mat-card-title>
                        <mat-card-subtitle class="mt-1 text-md">{{ offer.ds_shortname }}</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content class="flex-auto px-4 mt-4">
                        <div class="flex items-center justify-between py-2 border-b">
                            <span class="text-secondary font-medium text-sm">Active Range</span>
                            <span class="font-semibold text-sm">{{ formatDate(offer.dt_start) }} - {{ formatDate(offer.dt_end) }}</span>
                        </div>
                        <div class="flex items-center justify-between py-3">
                            <span class="text-secondary font-medium text-sm">Current Status</span>
                            <span class="rounded-full px-3 py-1 text-xs font-bold whitespace-nowrap"
                                  [ngClass]="[getOfferDetailedStatus(offer.dt_start, offer.dt_end).color, getOfferDetailedStatus(offer.dt_start, offer.dt_end).pulse ? 'animate-pulse shadow-sm' : '']">
                                {{ getOfferDetailedStatus(offer.dt_start, offer.dt_end).text }}
                            </span>
                        </div>
                    </mat-card-content>
                    <mat-card-actions class="p-4 pt-0">
                        <button mat-flat-button color="primary" class="w-full" (click)="openOfferDialog(offer)">
                            <mat-icon svgIcon="heroicons_outline:pencil" class="mr-2"></mat-icon>
                            <span>{{ reviewMode ? 'View Details' : 'Edit ' + termItem }}</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </ng-container>

        <ng-template #noOffers>
            <div class="flex flex-col items-center justify-center w-full h-full p-8 sm:p-16">
                <ng-container *ngIf="isLoading">
                    <ngx-spinner
                        bdColor="rgba(51,51,51,0)"
                        color="#1e293b"
                        size="medium"
                        type="ball-clip-rotate-multiple">
                    </ngx-spinner>
                </ng-container>
                <ng-container *ngIf="!isLoading">
                    <mat-icon class="icon-size-24 text-disabled" svgIcon="heroicons_outline:tag"></mat-icon>
                    <div class="mt-4 text-2xl font-semibold tracking-tight text-center">
                        {{ loadingMessage }}
                    </div>
                </ng-container>
            </div>
        </ng-template>
    </div>

    <mat-paginator
        class="flex-shrink-0 border-t bg-card dark:bg-gray-800"
        (page)="searchElements('paginator', $event)"
        [ngClass]="{'pointer-events-none': isLoading}"
        [length]="20"
        [pageIndex]="0"
        [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 100]"
        [showFirstLastButtons]="!isMobile">
    </mat-paginator>

</div>

<ng-template #offerDialog>
    <div class="flex flex-col max-h-full" *ngIf="selectedSpecialOfferForm">
        <div class="flex items-center justify-between flex-0 px-6 py-4 border-b bg-gray-50 dark:bg-gray-800/50">
            <h2 mat-dialog-title class="!m-0 text-2xl font-bold">
                {{ selectedSpecialOffer.id_offer ? (reviewMode ? termItem + ' Details' : 'Edit ' + termItem) : 'Create ' + termItem }}
            </h2>
            <button mat-icon-button [mat-dialog-close]="undefined">
                <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
        </div>

        <mat-dialog-content class="p-0 custom-scrollbar">
            <form class="flex flex-col" [formGroup]="selectedSpecialOfferForm">
                <mat-tab-group class="w-full" animationDuration="0ms">

                    <mat-tab [label]="termItem + ' Details'">
                        <div class="flex flex-col sm:flex-row p-6 sm:p-8 gap-8">
                            <div class="flex flex-col items-center w-full sm:w-1/3 shrink-0">
                                <div class="relative w-full aspect-[3/4] max-w-[240px] rounded-2xl overflow-hidden group shadow-md border bg-gray-100 dark:bg-gray-800">
                                    <img [src]="imageURLHelper"
                                         class="w-full h-full object-contain"
                                         onerror="this.src='https://media.myaltituderewards.com/content/undefined'"
                                         alt="{{ termItem }} image">
                                    <div class="absolute inset-0 bg-black/50 transition-opacity opacity-0 group-hover:opacity-100 flex items-center justify-center backdrop-blur-sm"
                                         *ngIf="!reviewMode">
                                        <button
                                            mat-flat-button color="primary" class="rounded-full shadow-lg"
                                            [disabled]="reviewMode"
                                            (click)="imageFileInput.click()">
                                            <mat-icon svgIcon="heroicons_outline:arrow-up-tray" class="mr-2"></mat-icon>
                                            <span>Upload Image</span>
                                        </button>
                                    </div>
                                    <input hidden type="file" #imageFileInput (change)="onChangeFile($event)" accept="image/*"/>
                                </div>
                                <div class="mt-3 text-sm font-medium text-red-500 bg-red-50 px-3 py-1 rounded-full" *ngIf="selectedSpecialOfferForm.get('im_media').hasError('required')">
                                    Cover image is required
                                </div>
                            </div>
                            <div class="flex flex-col w-full sm:w-2/3 gap-4">
                                <mat-form-field class="w-full">
                                    <mat-label>{{ termItem }} Title</mat-label>
                                    <input matInput [readonly]="reviewMode" formControlName="ds_offer" placeholder="{{ isAmbassador ? 'e.g. City Sightseeing Tour' : 'e.g. 20% Off Weekend Stay' }}">
                                </mat-form-field>

                                <mat-form-field class="w-full">
                                    <mat-label>Short Title (For Notifications & Labels)</mat-label>
                                    <input matInput [readonly]="reviewMode" formControlName="ds_shortname" maxlength="25" (input)="onInputMaxReach($event, 25)">
                                    <mat-hint align="end">{{selectedSpecialOfferForm.get('ds_shortname').value?.length || 0}}/25</mat-hint>
                                </mat-form-field>

                                <mat-form-field class="fuse-mat-textarea w-full">
                                    <mat-label>Full Description</mat-label>
                                    <textarea matInput [readonly]="reviewMode" formControlName="tx_description" [rows]="4" placeholder="Detail what the {{ termItemLower }} includes..."></textarea>
                                </mat-form-field>

                                <div class="flex flex-col sm:flex-row gap-4 mt-2">
                                    <mat-form-field class="w-full sm:w-1/2">
                                        <mat-label>Start Date</mat-label>
                                        <input matInput [matDatepicker]="startDatepicker" [formControl]="dtStartDate" (dateChange)="onDateChange($event)" readonly (focus)="startDatepicker.open()">
                                        <mat-datepicker-toggle matSuffix [for]="startDatepicker" [disabled]="reviewMode"></mat-datepicker-toggle>
                                        <mat-datepicker #startDatepicker [disabled]="reviewMode"></mat-datepicker>
                                    </mat-form-field>

                                    <mat-form-field class="w-full sm:w-1/2">
                                        <mat-label>End Date</mat-label>
                                        <input matInput [matDatepicker]="endDatepicker" [formControl]="dtEndDate" (dateChange)="onDateChange($event)" readonly (focus)="endDatepicker.open()">
                                        <mat-datepicker-toggle matSuffix [for]="endDatepicker" [disabled]="reviewMode"></mat-datepicker-toggle>
                                        <mat-datepicker #endDatepicker [disabled]="reviewMode"></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div class="flex items-center justify-end -mt-2 mb-2" *ngIf="!reviewMode">
                                    <button mat-button type="button" color="primary" (click)="makeOfferOngoing()">
                                        <mat-icon svgIcon="heroicons_outline:calendar-days" class="mr-2"></mat-icon>
                                        Set to Ongoing (5 Years)
                                    </button>
                                </div>

                                <div class="text-orange-600 bg-orange-50 px-4 py-2 rounded-md text-sm font-medium transition-all" *ngIf="flashMessage === 'dateChange'">
                                    <mat-icon svgIcon="heroicons_outline:exclamation-circle" class="icon-size-4 mr-1 inline align-text-bottom"></mat-icon>
                                    End date was automatically adjusted to be after the start date.
                                </div>
                            </div>
                        </div>
                    </mat-tab>

                    <mat-tab label="Redemption Rules">
                        <div class="flex flex-col p-6 sm:p-8 gap-8">

                            <div class="bg-blue-50 dark:bg-blue-900/20 text-blue-800 dark:text-blue-200 p-5 rounded-2xl flex gap-4 items-start shadow-sm border border-blue-100 dark:border-blue-800/30">
                                <mat-icon svgIcon="heroicons_outline:information-circle" class="text-blue-500 mt-0.5"></mat-icon>
                                <div class="flex flex-col gap-1">
                                    <span class="font-bold text-base mb-1">Understanding Limits</span>
                                    <span class="text-sm leading-relaxed"><b>Global Redeems:</b> Total amount of times this {{ termItemLower }} can be claimed across all users combined.</span>
                                    <span class="text-sm leading-relaxed"><b>Redeems per Member:</b> The maximum number of times an individual user can claim this {{ termItemLower }}.</span>
                                    <span class="text-sm mt-2 font-medium bg-blue-100 dark:bg-blue-900/50 inline-block px-3 py-1 rounded-md self-start">Tip: Set limits to -1 for unlimited redemptions.</span>
                                </div>
                            </div>

                            <div class="flex flex-col sm:flex-row gap-6">
                                <mat-form-field class="w-full sm:w-1/2">
                                    <mat-label>Global Redeems</mat-label>
                                    <mat-icon matPrefix svgIcon="heroicons_outline:globe-alt" class="mr-2"></mat-icon>
                                    <input matInput type="number" [readonly]="reviewMode" formControlName="vi_maxglobalredeem" (input)="onInputChange($event, 'vi_maxglobalredeem')">
                                </mat-form-field>

                                <mat-form-field class="w-full sm:w-1/2">
                                    <mat-label>Redeems per Member</mat-label>
                                    <mat-icon matPrefix svgIcon="heroicons_outline:user" class="mr-2"></mat-icon>
                                    <input matInput type="number" [readonly]="reviewMode" formControlName="vi_maxmemberredeem" (input)="onInputChange($event, 'vi_maxmemberredeem')">
                                </mat-form-field>
                            </div>

                            <mat-divider></mat-divider>

                            <div class="flex flex-col gap-4">
                                <div>
                                    <h3 class="text-lg font-semibold mb-1">Redemption Method</h3>
                                    <p class="text-secondary text-sm mb-4">Choose how users will redeem this {{ termItemLower }} at your property.</p>
                                </div>

                                <mat-form-field class="w-full">
                                    <mat-label>Redeem Type</mat-label>
                                    <mat-select formControlName="en_redeemtype" [disabled]="reviewMode">
                                        <mat-option *ngFor="let type of redeemTypes" [value]="type.value">
                                            {{ type.viewValue }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-hint class="text-primary mt-1">{{ getCurrentRedeemDescription() }}</mat-hint>
                                </mat-form-field>

                                <div class="mt-6 flex flex-col gap-4 bg-gray-50 dark:bg-gray-800/50 p-6 rounded-xl border" *ngIf="selectedSpecialOfferForm.get('en_redeemtype').value === 1">
                                    <div class="flex items-center gap-2 mb-2">
                                        <mat-icon svgIcon="heroicons_outline:qr-code" class="text-secondary"></mat-icon>
                                        <span class="font-semibold">Auto-Redeem Configuration</span>
                                    </div>

                                    <mat-form-field class="w-full">
                                        <mat-label>Redeem Data Link (e.g., URL to external system)</mat-label>
                                        <input matInput [readonly]="reviewMode" formControlName="tx_redeemdata">
                                    </mat-form-field>

                                    <div class="flex flex-col sm:flex-row gap-6">
                                        <mat-form-field class="w-full sm:w-1/2">
                                            <mat-label>Internal Code Type</mat-label>
                                            <mat-select formControlName="en_internalcodetype" [disabled]="reviewMode">
                                                <mat-option *ngFor="let type of internalCodeTypes" [value]="type.value">
                                                    {{ type.viewValue }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field class="w-full sm:w-1/2">
                                            <mat-label>Internal Code Value</mat-label>
                                            <input matInput [readonly]="reviewMode" formControlName="ds_internalcode" maxlength="50" placeholder="e.g. SUMMER2024">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>

                </mat-tab-group>
            </form>
        </mat-dialog-content>

        <mat-dialog-actions class="px-6 py-4 border-t bg-gray-50 dark:bg-gray-800/50 flex justify-between items-center" *ngIf="!reviewMode">
            <button
                *ngIf="selectedSpecialOffer.id_offer"
                mat-stroked-button color="warn"
                (click)="deleteSpecialOffer()">
                <mat-icon svgIcon="heroicons_outline:trash" class="mr-2"></mat-icon>
                Delete {{ termItem }}
            </button>
            <span *ngIf="!selectedSpecialOffer.id_offer"></span>

            <div class="flex gap-2">
                <button mat-button [mat-dialog-close]="undefined">
                    Cancel
                </button>
                <button
                    mat-flat-button color="primary"
                    [disabled]="selectedSpecialOfferForm.invalid || selectedSpecialOfferForm.pristine"
                    (click)="saveSpecialOffer()">
                    <mat-icon svgIcon="heroicons_outline:check" class="mr-2"></mat-icon>
                    {{ selectedSpecialOffer.id_offer ? "Save Changes" : "Create " + termItem }}
                </button>
            </div>
        </mat-dialog-actions>
    </div>
</ng-template>
